import firebase from "firebase/app";
import "firebase/firestore";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyA7P4FgtqJkEQDaKdRJV4fftXCzNmKb0kY",
  authDomain: "my-website-da58d.firebaseapp.com",
  databaseURL: "https://my-website-da58d.firebaseio.com",
  projectId: "my-website-da58d",
  storageBucket: "my-website-da58d.appspot.com",
  messagingSenderId: "548105223421",
  appId: "1:548105223421:web:36c8956aa77e3d9a"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

export default db;



// WEBPACK FOOTER //
// ./src/services/firebase.js